import tippy from 'tippy.js';

export const tippyModule = () => {
    const tippyElements = document.querySelectorAll('[js-tippy]');
    if (!tippyElements.length) return;

    tippyElements.forEach(element => {
        tippy(element, {
            content: element.getAttribute('js-tippy'),
            allowHTML: true,
            trigger: 'mouseenter click',
        });
    });
};
